/* Gallery controls delegate to the theme's media-gallery, including 3D/video. */
if (!customElements.get('woodlas-gallery-navigation')) {
  customElements.define('woodlas-gallery-navigation', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      if (!this.gallery) return;
      this.controller = new AbortController();
      this.buttons = [...this.querySelectorAll('[data-studio-step]')];
      this.counter = this.querySelector('[data-studio-counter]');
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const slides = this.slides();
        const current = slides.findIndex(slide => slide.classList.contains('is-active'));
        const next = slides[(Math.max(0, current) + Number(button.dataset.studioStep) + slides.length) % slides.length];
        if (next && this.gallery.setActiveMedia) this.gallery.setActiveMedia(next.dataset.mediaId, false);
      }, { signal: this.controller.signal }));
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.gallery.querySelector('.product__media-list'), { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      this.update();
    }
    slides() { return [...this.gallery.querySelectorAll('.product__media-list > [data-media-id]')]; }
    update() {
      const slides = this.slides();
      const index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      const value = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      if (this.counter.textContent !== value) this.counter.textContent = value;
      this.buttons.forEach(button => button.disabled = slides.length < 2);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
